
import { useDispatch, useSelector } from "react-redux";
import { clearItems, addItem, deleteItem } from "../features/bookInvoiceSlice";  // Import actions
import { RootState } from "../store/store";  // Import your Redux root state type
import { BookData } from "../types/bookInvoice";

export function useBookInvoices() {
  const dispatch = useDispatch();
  const bookInvoices = useSelector((state: RootState) => state.bookInvoices); // Get invoices from Redux state

  const addMultipleBookInvoices = (bookData: BookData[]) => {
    bookData.forEach((bookData) => {
      dispatch(addItem(bookData));  // Dispatch action to add invoice
    });
  };

  const addBookInvoice = (bookData: BookData) => {
    dispatch(addItem(bookData));  // Dispatch action to add a single invoice
  };

  const removeBookInvoice = (id: number) => {
    dispatch(deleteItem({ id }));  // Dispatch action to delete invoice by id
  };

  const clearBookInvoices = () => {
    dispatch(clearItems(bookInvoices));  // Dispatch action to clear all invoices
  };

  return {
    bookInvoices,
    addMultipleBookInvoices,
    addBookInvoice,
    clearBookInvoices,
    removeBookInvoice,
  };
}
